import React from 'react';
import { motion } from 'framer-motion';
import {
  ShieldCheckIcon,
  WrenchScrewdriverIcon,
  CurrencyDollarIcon,
  ArrowRightIcon
} from '@heroicons/react/24/outline';
import Footer from '../components/Footer';
import StatsWidget from '../components/StatsWidget';

function FeatureCard({ icon: Icon, title, description }) {
  return (
    <motion.div
      whileHover={{ y: -5 }}
      className="card p-6"
    >
      <Icon className="h-12 w-12 text-gray-custom-400 mb-4" />
      <h3 className="text-xl font-semibold mb-2 text-gray-custom-100">{title}</h3>
      <p className="text-gray-custom-400">{description}</p>
    </motion.div>
  );
}

function Home() {
  const features = [
    {
      icon: ShieldCheckIcon,
      title: "Powerful Moderation",
      description: "Keep your server safe with advanced moderation tools and automated protection."
    },
    {
      icon: WrenchScrewdriverIcon,
      title: "Utility Commands",
      description: "Essential tools and commands to help manage and enhance your Discord server."
    },
    {
      icon: CurrencyDollarIcon,
      title: "Economy System",
      description: "Engage your community with a fully-featured economy system and custom shops."
    }
  ];

  return (
    <div>
      {/* Hero Section */}
      <div className="container-custom py-24">
        <div className="text-center mb-16">
          <motion.h1
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="heading-1 text-gray-custom-100 mb-4"
          >
            The Ultimate Discord Bot
          </motion.h1>
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.2 }}
            className="text-xl text-gray-custom-400 max-w-3xl mx-auto mb-8"
          >
            Enhance your Discord server with powerful moderation, utility commands, and an engaging economy system.
          </motion.p>
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.4 }}
          >
            <a
              href="https://discord.com/api/oauth2/authorize?client_id=YOUR_CLIENT_ID&permissions=8&scope=bot"
              target="_blank"
              rel="noopener noreferrer"
              className="btn btn-primary text-lg px-8 py-4 inline-flex items-center gap-2"
            >
              Add to Discord
              <ArrowRightIcon className="h-5 w-5" />
            </a>
          </motion.div>
        </div>

        {/* Stats Widget */}
        <StatsWidget />

        {/* Features Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-16">
          {features.map((feature, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.2 * index }}
            >
              <FeatureCard {...feature} />
            </motion.div>
          ))}
        </div>

        {/* CTA Section */}
        <div className="text-center">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.6 }}
            className="card p-8 max-w-3xl mx-auto"
          >
            <h2 className="text-2xl font-semibold text-gray-custom-100 mb-4">
              Ready to take your server to the next level?
            </h2>
            <p className="text-gray-custom-400 mb-6">
              Join thousands of servers already using Overseer to enhance their Discord experience.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <a
                href="/docs"
                className="btn btn-secondary text-lg px-6 py-3"
              >
                View Documentation
              </a>
              <a
                href="/premium"
                className="btn btn-primary text-lg px-6 py-3"
              >
                Upgrade to Premium
              </a>
            </div>
          </motion.div>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default Home;